import { EventEmitter2 } from 'eventemitter2';

import gtmEventHandlers from '../gtmEventHandlers';

class GTMEventEmitter {
  constructor() {
    this.eventHandlers = gtmEventHandlers;
    this.acceptedEvents = this.eventHandlers.acceptedEvents || {};
    this.eventEmitter = new EventEmitter2();
    this.silent = false;
    this.addEventHandlers(this.acceptedEvents);
  }

  setStore(store) {
    this.store = store;
    this.eventHandlers.getState = store.getState;
  }

  setSilent(silent) {
    this.silent = silent;
  }

  /**
   * Trigger a GTM event
   * @param  {keyof typeof gtmEventHandlers.acceptedEvents} event Event name
   * @param  {...any} args Event data
   */
  trigger(event, ...args) {
    try {
      this.eventEmitter.emit(event, ...args);
    } catch (e) {
      if (!this.silent) {
        console.log('GTM Event trigger error', e); // eslint-disable-line no-console
      }
    }
  }

  triggerAsync(...args) {
    return this.eventEmitter.emitAsync(...args);
  }

  addEventHandlers(acceptedEvents) {
    Object.keys(acceptedEvents).forEach(eventName => {
      const handlerName = this.acceptedEvents[eventName];
      if (typeof this.eventHandlers[handlerName] === 'function') {
        this.eventEmitter.on(eventName, this.eventHandlers[handlerName].bind(this.eventHandlers));
      }
    });
  }
}

// export as singleton
const gtmEventEmitter = new GTMEventEmitter();

export default gtmEventEmitter;
